import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import { getCurrentRole, getLMSOperationActivity, getOperationActivityUrl, getVesselOperation } from "../../../services/commonFunction";
import ConfirmationModal from "../ConfirmationModal";
import { decryptDataForURL } from "../../../utills/useCryptoUtils";
import { Button } from "react-bootstrap";
const OperationCertificateButtons = ({
  status,
  moduleSubType,
  RPCID,
  encryptDataForURL,
  EditRecordId,
  JISID,
  previewCertificate,
  generateCertificate,
  isValideValue,
  handleShareFile,
  EditGeneratedCertificate,
  OperationType,
  resendShareFile = false,
  operationMode,
  isCustomMode,
  directUpload,
  setUploadPopup,
  setPopupType,
  formData,
  setIsRejectPopupOpen,
  setIsCancelPopupOpen,
}) => {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const useForCancel = decryptDataForURL(params.get("useForCancel"));
  const iscustomformatupload = decryptDataForURL(params.get("iscustomformatupload"));
  const { t } = useTranslation();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const translate = t;
  let navigate = useNavigate();
  const handleConfirm = (isWeighted) => {
    if (status === "Edit") {
      EditGeneratedCertificate("posted", "", isWeighted)
    }
    else {
      generateCertificate(status, "posted", "", "", isWeighted)
    }
    setIsConfirmOpen(false)
  }
  if (status === "View") {
    let viewVuttoons = null
    if (useForCancel) {
      viewVuttoons = useForCancel && !formData[0]?.cc_is_request_for_cancel ? (<button
        onClick={() => {
          setIsRejectPopupOpen(true)
          setIsCancelPopupOpen(true)
        }}
        className="submitBtn compBtn"
        type="button"
      >
        Cancel Certificate
      </button>) : (<>
        <Button
          type="button"
          className="submitBtn"
          id="submit_btn1"
          onClick={(e) => {
            setIsRejectPopupOpen(true)
            setIsCancelPopupOpen(false)
          }
          }
        >
          Reject
        </Button>
        <Button
          type="button"
          className="submitBtn"
          id="submit_btn1"
          onClick={(e) => {
            setIsRejectPopupOpen(true)
            setIsCancelPopupOpen(true)
          }
          }
        >
          Cancel certificate
        </Button></>)
    }
    else if (iscustomformatupload) {
      viewVuttoons = (<button
        className="submitBtn compBtn"
        type="button"
        onClick={() => {
          setPopupType("Upload")
          setUploadPopup(true)
        }}
      >
        Upload
      </button>)
    }
    return (
      <>
        <div className="submit_btns">
          <button
            onClick={() => { navigate(-1); }}
            className="cancelBtn"
            type="button"
          >
            Back
          </button>
          {viewVuttoons}
        </div>
      </>
    )
  }
  return isCustomMode ? <>
    <div className="submit_btns">
      <button
        onClick={() => { navigate(-1); }}
        className="cancelBtn"
        type="button"
      >
        Back
      </button>
      {
        !formData[0]?.cc_id && !directUpload && (<button
          className="saveBtn compBtn"
          type="button"
          onClick={() => generateCertificate("uploadedDocument", "saved", 1)}
          disabled={!isValideValue}
        >
          Generate
        </button>)
      }

      {(formData[0]?.cc_id || directUpload) && <button
        className="submitBtn compBtn"
        type="button"
        onClick={() => {
          setPopupType("Upload")
          setUploadPopup(true)
        }}
      >
        Upload
      </button>}
    </div>
  </> : (
    <>
      <div className="submit_btns">
        {status !== "Edit" && moduleSubType !== "ShareFiles" && (
          <button
            onClick={() => {
              const redirectUrl = getOperationActivityUrl(operationMode)
              !getLMSOperationActivity().includes(OperationType) ?
                // navigate(
                //   `/operation/vessel-ji-list/vessel-list/${encryptDataForURL(EditRecordId)}`
                // )
                navigate(-1)
                : navigate(
                  `${redirectUrl}confirugation-certificate-list/${encryptDataForURL(EditRecordId)}/${encryptDataForURL(JISID)}?OperationType=${encryptDataForURL(OperationType)}` + "&operationMode=" + encryptDataForURL(operationMode)
                )

            }}
            className="cancelBtn"
            type="button"
          >
            Back
          </button>
        )}
        {status === "approve" && (
          <button
            className="submitBtn"
            type="button"
            onClick={() => previewCertificate(RPCID)}
          >
            Preview
          </button>
        )}

        {status !== "approve" &&
          status !== "Edit" &&
          moduleSubType !== "ShareFiles" && (
            <>
              <button
                className="saveBtn compBtn"
                type="button"
                onClick={() => generateCertificate(status, "saved")}
                disabled={!isValideValue || (OperationType === getVesselOperation("DS") && formData[0]?.ds_options?.length === 0)}
              >
                Save
              </button>
              <button
                className="submitBtn compBtn"
                type="button"
                onClick={() => {
                  // if (OperationType === getVesselOperation('DS')) {
                  //   setIsConfirmOpen(true)
                  // }
                  // else {
                  generateCertificate(status, "posted")
                  // }
                }}
                disabled={!isValideValue || (OperationType === getVesselOperation("DS") && formData[0]?.ds_options?.length === 0)}
              >
                Generate
              </button>
            </>
          )}
        {moduleSubType === "ShareFiles" && (
          <button
            onClick={() => {
              navigate(-1);
            }}
            className="cancelBtn"
            type="button"
          >
            Back
          </button>
        )}
        {moduleSubType === "ShareFiles" && (

          resendShareFile ?
            <button
              className="submitBtn"
              type="button"
              onClick={() => handleShareFile(true)}
            >
              Resend
            </button> : <button
              className={"submitBtn " + (!isValideValue && "")}
              type="button"
              // disabled={!isValideValue}
              onClick={(e) => {
                handleShareFile();
                // setTimeout(() => {
                //   e.target.blur();
                // }, 3000);
              }}
            >
              Share File
            </button>

        )}

        {status === "Edit" && (
          <>

            <button
              onClick={() => {
                navigate("/operation/commercial-certificate-list");
              }}
              className="cancelBtn"
              type="button"
            >
              Back
            </button>
            {!['SU'].includes(getCurrentRole()) && <button
              className="saveBtn"
              type="button"
              onClick={() => EditGeneratedCertificate("saved")}
              disabled={OperationType === getVesselOperation("DS") && formData[0]?.ds_options?.length === 0}
            >
              Save
            </button>}
            <button
              className="submitBtn"
              type="button"
              // onClick={() => EditGeneratedCertificate("posted")}
              onClick={() => {
                // if (OperationType === getVesselOperation('DS')) {
                //   setIsConfirmOpen(true)
                // }
                // else {
                EditGeneratedCertificate("posted")
                // }

              }}
              disabled={OperationType === getVesselOperation("DS") && formData[0]?.ds_options?.length === 0}
            >
              {['SU'].includes(getCurrentRole()) ? 'Save' : 'Generate'}
            </button>
          </>
        )}
      </div>
      <ConfirmationModal isOpen={isConfirmOpen} handleClose={() => handleConfirm()} handleConfirm={() => handleConfirm(true)} popupMessage={"Do you want to generate it with a weighted certificate?"} popupHeading={"Weighted Certificate"} popbuttons={{ no: "No", yes: "Yes" }} setPopupClose={setIsConfirmOpen} />
    </>
  );
};


OperationCertificateButtons.propTypes = {
  setIsPopupOpen: PropTypes.func,
  setJRFCreationType: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleBackButtonFunction: PropTypes.func,
  viewOnly: PropTypes.bool,
};

export default OperationCertificateButtons;